import { IDeleteUserAvatarRequest } from "api/models/request/IDeleteUserAvatarRequest";
import { deleteAvatar } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { useCallback } from "react";

export const useDeleteAvatar = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IDeleteUserAvatarRequest, any>(deleteAvatar, 'profile.deleteAvatarSuccess', 'profile.deleteAvatarError');
    
    const deleteUserAvatar = useCallback(async (userId: string | undefined) => {
        return await callAPI({ userId });
    }, [callAPI]);

    return { deleteAvatar: deleteUserAvatar, deleteAvatarPending: loading }
}